<script>
  import PharmacySearchResultTile from '../PharmacySearchResultTile/PharmacySearchResultTile.svelte';
  import PharmacySearchResultSkeletonTile from '../PharmacySearchResultSkeletonTile/PharmacySearchResultSkeletonTile.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import searchValue from '../../stores/search';
  import { SPRITESHEET_URL } from '../../utils/constants';
  import { RecentPharmacySearches } from '../../utils/local-storage';

  let {
    pharmacySearchResultTile,
    errorText,
    recentSearchesText,
    clearRecentSearchesText,
    popularSearchesText,
    popularPharmaciesList,
    id,
    selected = $bindable(),
    isError,
    searchResults,
    resultTiles = $bindable(),
    parentComponent,
    dataTestId = 'pharmacy-search-overpanel-results',
  } = $props();
  
  let recentSearches = $state([]);

  try {
    recentSearches = RecentPharmacySearches.get();
  } catch {
    recentSearches = [];
  }

  const handleClearButtonClick = (search) => {
    RecentPharmacySearches.remove(search);
    try {
      recentSearches = RecentPharmacySearches.get();
    } catch {
      recentSearches = [];
    }
  };

  const handleClearAll = () => {
    RecentPharmacySearches.clear();
    recentSearches = [];
  };
</script>

<div data-testid={dataTestId}>
  <ul {id} class="p-4 mt-4" class:hidden={!searchResults.length} aria-label="Search Results">
    {#each searchResults as group, index (index)}
      <h3 class="mb-2">{group[0]}</h3>
      {#each group[1] as item, i (i)}
        <li id={`search-result-${i}`} tab-index="-1" class="mb-4" bind:this={resultTiles[i]}>
          <PharmacySearchResultTile
            {...item}
            {...pharmacySearchResultTile}
            {parentComponent}
            focusCallback={() => (selected = item.slug)}
            blurCallback={() => {
              if (selected === item.slug) {
                selected = undefined;
              }
            }}
          />
        </li>
      {/each}
    {/each}
  </ul>
  {#if isError}
    <div data-testid="{dataTestId}-error-text" class="px-10 py-16 flex-1">
      <p class="text-base leading-snug text-center text-gray-gunmetal">{errorText}</p>
    </div>
  {:else if !searchResults.length}
    <div class="px-4 pt-2">
      {#if $searchValue}
        <ul>
          {#each Array(5)}
            <li class="mb-4">
              <PharmacySearchResultSkeletonTile />
            </li>
          {/each}
        </ul>
      {:else if recentSearches.length}
        <div class="flex flex-row justify-between items-center mb-2">
          <div class="text-base leading-loose text-blue-dark-navy">{recentSearchesText}</div>
          <button
            class="flex flex-row items-center text-xs text-blue-cerulean font-semibold leading-normal py-2 px-1
            hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:underline active:text-blue-darkish"
            onclick={handleClearAll}
            data-testid="{dataTestId}-clear-all-button"
          >
            {clearRecentSearchesText}
            <svg class="ml-2 w-4 h-4 fill-current inline-block" role="presentation">
              <use xlink:href="{SPRITESHEET_URL}clear-x" />
            </svg>
          </button>
        </div>
        <ul>
          {#each recentSearches as item, index (index)}
            <li class="mb-4">
              <PharmacySearchResultTile
                name={!item._tags
                  ? item.name
                  : item._tags !== 'nationwide'
                    ? `${item.name} - ${item._tags}`
                    : item.name}
                slug={item.slug}
                count={item.count}
                url={item.url}
                {...pharmacySearchResultTile}
                {handleClearButtonClick}
                {parentComponent}
              />
            </li>
          {/each}
        </ul>
      {:else if popularPharmaciesList && popularPharmaciesList.popularPharmacies}
        <div class="mb-2 text-base leading-loose text-blue-dark-navy">{popularSearchesText}</div>
        <ul class="flex flex-wrap pb-3">
          {#each popularPharmaciesList.popularPharmacies as { name, link }, index (index)}
            <li class="inline-flex mr-3 mb-3" data-testid="{dataTestId}-popular-pharmacy-item">
              <BaseLink
                className="px-6 py-1 shadow-medium font-semibold rounded bg-white text-base leading-loose text-center text-blue-navy 
                relative pseudo-shadow-tight-hover active:shadow-active"
                url={link.url}
              >
                {name}
              </BaseLink>
            </li>
          {/each}
        </ul>
      {/if}
    </div>
  {/if}
</div>
